export const lares = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 25,
  inputPaddingInline: 10,

  inputHeight: 50,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 17,
  inputFontFamily: '"Lato", sans-serif',
  inputColor: "#000000",
  inputBackgroundColor: "#ffffff",
  inputFontWeight: 400,

  inputBorderColor: "#D3D3D3",
  inputBorderWidth: 1,
  inputBorderRadius: 0,

  inputHoverColor: "#000000",
  inputHoverBorderColor: "#D3D3D3",
  inputHoverBackgroundColor: "#ffffff",

  // **********************************
  //  Select field
  selectTopSpacing: 25,
  selectPaddingInline: 10,

  selectHeight: 50,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 17,
  selectFontFamily: '"Lato", sans-serif',
  selectColor: "#000000",
  selectBackgroundColor: "#F0F0F0",
  selectFontWeight: 400,

  selectBorderColor: "transparent",
  selectBorderWidth: 1,
  selectBorderRadius: 0,

  selectHoverColor: "transparent",
  selectHoverBorderColor: "#D3D3D3",
  selectHoverBackgroundColor: "#F0F0F0",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 25,
  textAreaPaddingInline: 10,

  textAreaHeight: 50,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 17,
  textAreaFontFamily: '"Lato", sans-serif',
  textAreaColor: "#000000",
  textAreaBackgroundColor: "#ffffff",
  textAreaFontWeight: 400,

  textAreaBorderColor: "#D3D3D3",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 0,

  textAreaHoverColor: "#000000",
  textAreaHoverBorderColor: "#D3D3D3",
  textAreaHoverBackgroundColor: "#ffffff",

  // **********************************
  //  placeholder
  placeholderColor: "#D3D3D3",
  placeholderFontFamily: '"Lato", sans-serif',
  placeholderFontSize: 17,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#D3D3D3",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 9,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 17,
  fieldLabelColor: "#000000",
  fieldLabelFontWeight: 400,
  fieldLabelColorAsterisk: "#000000",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Lato", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#000000",
  descriptionFontSize: 14,
  descriptionFontWeight: 400,
  descriptionFontFamily: '"Lato", sans-serif',
  descriptionTopSpacing: 10,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 12,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 1,
  checkboxUncheckedBorderColor: "#D3D3D3",
  checkboxUncheckedBackgroundColor: "#ffffff",
  checkboxCheckedBackgroundColor: "#460000",
  checkboxCheckedBorderColor: "#D3D3D3",
  checkboxCheckedColor: "#ffffff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Lato", sans-serif',
  checkboxLabelFontSize: 14,
  checkboxLabelFontWeight: 400,
  checkboxLabelColor: "#000000",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 12,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#D3D3D3",
  radioUncheckedBackgroundColor: "#ffffff",
  radioCheckedBackgroundColor: "#460000",
  radioCheckedBorderColor: "#D3D3D3",

  radioAlignment: "none",

  radioLabelFontFamily: '"Lato", sans-serif',
  radioLabelFontSize: 14,
  radioLabelFontWeight: 400,
  radioLabelColor: "#000000",

  // **********************************
  // submit button

  submitMarginTop: 40,
  submitFontSize: 17,
  submitFontFamily: "'Lato', sans-serif",
  submitWidth: 130,
  submitWidthUnits: "px",
  submitHeight: 65,
  submitBorderRadius: 0,
  submitBorderWidth: 1,
  submitBackground: "#460000",
  submitColor: "#ffffff",
  submitBorderColor: "#460000",
  submitBackgroundHover: "#460000",
  submitBorderColorHover: "#460000",
  submitColorHover: "#ffffff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 500,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "left",
};

  